/*eslint-disable no-undef,no-redeclare,no-empty,no-unused-vars */
import April from '../../ALizard/April'

export default ()=>{

    April.define("DisplayComponent/defence.guard", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/defence.guard" });
            args.tweener
                .call(function(_args){
                    phina.display.Label({
                        text:'Guard！',fontSize:30,
                        stroke:'#000', fill:'#FFF', strokeWidth:3,
                    }).addChildTo(ch)
                    .setPosition(-20,-20)
                    .tweener
                        .wait(1000)
                        .fadeOut(100)
                        .call(function(){ this.remove(); });
                }, null, [args]);
        }
    });

    April.define("log.protect", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            var t = args.scene.member[args.target];
            scene.flare("act_console", { value: "call DisplayComponent/defence.protect" });
            args.tweener
                .call(function(_args){
                    phina.display.Label({
                        text:'Protect！',fontSize:30,
                        stroke:'#000', fill:'#FFF', strokeWidth:3,
                    }).addChildTo(ch)
                    .setPosition(-20,-20)
                    .tweener
                        .wait(1000)
                        .fadeOut(100)
                        .call(function(){ this.remove(); });
                    phina.display.Label({
                        text:'Protected！',fontSize:30,
                        stroke:'#000', fill:'#FFF', strokeWidth:3,
                    }).addChildTo(t)
                    .setPosition(-20,-20)
                    .tweener
                        .wait(1000)
                        .fadeOut(100)
                        .call(function(){ this.remove(); });
                }, null, [args])
        }
    });
}
